/** Korean strings. Keys are shared with ./en.js — keep the two in step. */
const ko = {
  common: {
    cancel: '취소',
    close: '닫기',
    remove: '삭제',
    retry: '초기화',
    loading: '불러오는 중…',
    refresh: '새로고침',
    language: '언어',
    back: '뒤로',
    save: '저장',
    next: '다음',
  },
  nav: {
    primary: '메인',
    home: 'LabelFlow 홈',
    openMenu: '메뉴 열기',
    closeMenu: '메뉴 닫기',
    management: '관리',
    aiAssistant: 'AI 어시스턴트',
    projectManagement: '프로젝트 관리',
    modelManagement: '모델 관리',
    datasetPrep: '데이터셋 준비',
    videoToImages: '동영상 → 이미지',
    publicHub: '퍼블릭 허브',
    modelHub: '모델 허브',
    inference: '추론',
    prediction: '예측',
    account: '계정',
    logout: '로그아웃',
    logoutConfirm: '로그아웃하시겠습니까?',
    themeLight: '라이트 모드로 전환',
    themeDark: '다크 모드로 전환',
  },
  videoToImages: {
    title: '동영상 → 이미지',
    subtitle:
      '백그라운드에서 동영상에서 JPEG 프레임을 추출합니다. 모델에 바로 보내거나, 데이터셋에 보관한 뒤 나중에 전송할 수 있습니다.',
    engine: {
      label: '추출 엔진',
      ffmpeg: 'ffmpeg',
      opencv: 'OpenCV',
      unknown: '확인 중…',
      hint: '자동으로 선택됩니다 — ffmpeg를 사용할 수 있으면 ffmpeg, 그렇지 않으면 OpenCV.',
    },

    target: {
      heading: '1. 이미지를 저장할 위치 선택',
      mode: '저장 위치',
      modeModel: '프로젝트 모델',
      modeDataset: '데이터셋',
      project: '프로젝트',
      model: '모델',
      selectProject: '프로젝트를 선택하세요',
      selectModel: '모델을 선택하세요',
      noModels: '이 프로젝트에는 아직 모델이 없습니다',
      hint: '선택한 모델 아래에 새 데이터셋 버전이 생성됩니다. 추출된 이미지는 라벨이 없는 상태로 저장되어 라벨링 도구에서 바로 열립니다.',
      datasetName: '데이터셋 이름',
      datasetPlaceholder: '예: 창고 카메라 — 3월',
      datasetHint: '프로젝트나 모델이 필요하지 않습니다. 이미지는 이 데이터셋에 보관되며, 나중에 원하는 이미지를 선택해 프로젝트 모델로 전송할 수 있습니다.',
      datasetExistsHint: '이미 있는 이름을 사용하면 해당 데이터셋에 새 이미지가 추가됩니다.',
      newProject: '+ 새 프로젝트',
      newModel: '+ 새 모델',
      newProjectName: '새 프로젝트 이름',
      newModelName: '새 모델 이름',
      newProjectPlaceholder: '예: 창고 안전',
      newModelPlaceholder: '예: 헬멧 검출기',
      modelKind: '모델 유형',
      kindClassification: '분류',
      kindDetection: '객체 검출',
      create: '생성',
      creating: '생성 중…',
      created: '“{name}”을(를) 생성했습니다.',
      createFailed: '생성할 수 없습니다',
      cancelCreate: '취소',
      nameRequired: '먼저 이름을 입력하세요.',
      missing: '먼저 프로젝트와 모델을 선택하세요.',
      datasetMissing: '먼저 데이터셋 이름을 입력하세요.',
    },

    upload: {
      heading: '2. 동영상 추가',
      dropHere: '동영상, 폴더 또는 .zip 파일을 여기에 끌어다 놓으세요',
      or: '또는',
      chooseFiles: '파일 선택',
      chooseFolder: '폴더 선택',
      supported: '지원 형식: {formats}',
      zipNote: 'zip 파일 내부를 재귀적으로 검색하며, 동영상이 아닌 항목은 무시합니다.',
      selectedCount: '{count}개 파일 선택됨',
      clearAll: '전체 지우기',
      uploading: '{name} 업로드 중…',
      uploadProgress: '{size} 중 {percent}%',
      staged: '{count}개 동영상 준비 완료',
      rejected: '{count}개 파일 건너뜀',
      rejectedHeading: '건너뛴 파일',
      uploadFailed: '업로드 실패',
      noneSelected: '동영상을 하나 이상 추가하세요.',
      totalSize: '총 {size}',
    },

    options: {
      heading: '3. 추출 옵션',
      sampling: '프레임 샘플링',
      samplingFps: '초당 프레임 수 지정',
      samplingNth: 'N번째 프레임마다',
      samplingCount: '전체 프레임 수 지정',
      fpsLabel: '초당 프레임 수',
      fpsHint: '1 fps는 동영상 1초마다 1개의 프레임을 추출합니다.',
      nthLabel: 'N번째 프레임마다 추출',
      nthHint: 'N = 30이면 30 fps 영상에서 약 1초에 1프레임이 추출됩니다.',
      countLabel: '동영상당 전체 프레임 수',
      countHint: '동영상 전체에서 균등한 간격으로 프레임을 추출합니다.',
      format: '출력 형식',
      quality: 'JPEG 품질',
      qualityHint: '값이 높으면 화질이 좋아지고 파일 크기가 커집니다.',
      resize: '크기 조정',
      resizeKeep: '원본 크기 유지',
      resizeMax: '최대 크기에 맞추기',
      maxWidth: '최대 너비',
      maxHeight: '최대 높이',
      resizeHint: '이미지는 축소만 되며, 가로세로 비율은 유지됩니다.',
    },

    start: {
      button: '변환 시작',
      starting: '시작 중…',
      queued: '변환이 대기열에 등록되었습니다 — 이 페이지를 벗어나도 됩니다.',
      failed: '변환을 시작할 수 없습니다',
    },

    jobs: {
      heading: '변환 작업',
      empty: '아직 변환 작업이 없습니다.',
      emptyHint: '위에서 동영상을 추가하고 변환을 시작하면 여기에 표시됩니다.',
      loadFailed: '변환 작업을 불러올 수 없습니다.',
      columnTarget: '대상',
      columnStatus: '상태',
      columnProgress: '진행률',
      columnImages: '이미지',
      columnCreated: '생성 일시',
      columnActions: '',
      sources: '동영상 {done}/{total}개',
      frames: '이미지 {count}개',
      framesOf: '이미지 {count}개 / 약 {total}개',
      version: '버전 {version}',
      datasetTarget: '데이터셋',
      openInLabeling: '라벨링',
      aiLabel: 'AI 라벨링',
      aiLabelTooltip: '이 버전의 라벨 없는 이미지를 AI로 분류하거나 박스를 그립니다',
      openInLabelingTooltip: '라벨링 도구에서 열기',
      openDataset: '데이터셋',
      openDatasetTooltip: '이 데이터셋 열기',
      viewDetails: '상세',
      viewDetailsTooltip: '작업 상세, 파일별 결과 및 로그',
      cancelJob: '취소',
      cancelJobTooltip: '이 변환 작업 취소',
      cancelConfirmTitle: '이 변환을 취소하시겠습니까?',
      cancelConfirmText: '이미 추출된 이미지는 그대로 유지되며 라벨링에 사용할 수 있습니다.',
      cancelled: '취소를 요청했습니다.',
      cancelFailed: '작업을 취소할 수 없습니다.',
      background: '이 페이지를 벗어나도 변환은 계속 실행됩니다.',
    },

    status: {
      queued: '대기 중',
      inProgress: '진행 중',
      complete: '완료',
      partiallyComplete: '부분 완료',
      failed: '실패',
      cancelled: '취소됨',
      unknown: '알 수 없음',
    },

    details: {
      heading: '작업 상세',
      output: '저장 위치',
      engineUsed: '엔진',
      optionsUsed: '옵션',
      perFile: '파일별 결과',
      fileName: '파일',
      fileStatus: '상태',
      fileFrames: '이미지',
      fileError: '원인',
      warnings: '경고',
      errors: '오류',
      skipped: '업로드 시 건너뜀',
      logs: '최근 로그',
      noLogs: '아직 로그가 없습니다.',
      totalProduced: '이미지 {count}개 생성됨',
      noneProduced: '생성된 이미지가 없습니다.',
    },

    datasets: {
      heading: '데이터셋',
      subtitle: '모델에 할당되기를 기다리는 추출된 이미지입니다.',
      empty: '아직 데이터셋이 없습니다.',
      emptyHint: '데이터셋 이름을 지정해 변환을 실행하면 여기에 표시됩니다.',
      loadFailed: '데이터셋을 불러올 수 없습니다.',
      images: '이미지 {count}개',
      open: '열기',
      backToList: '전체 데이터셋',
      selectAll: '전체 선택',
      clearSelection: '선택 해제',
      selected: '{count}개 선택됨',
      selectHint: '이미지를 선택한 뒤 원하는 프로젝트 모델로 전송하세요.',
      transfer: '라벨링 준비',
      removeSelected: '삭제',
      removeConfirmTitle: '선택한 이미지를 삭제하시겠습니까?',
      removeConfirmText: '이 데이터셋에서만 삭제됩니다. 이미 모델로 전송된 복사본은 영향을 받지 않습니다.',
      removed: '이미지 {count}개를 삭제했습니다.',
      removeFailed: '이미지를 삭제할 수 없습니다.',
      noneSelected: '이미지를 하나 이상 선택하세요.',
      alreadySent: '모델 {count}개로 전송됨',
      loadMore: '더 보기',
      showing: '{total}개 중 {shown}개 표시',
      deleteDataset: '데이터셋 삭제',
      deleteDatasetConfirmTitle: '이 데이터셋을 삭제하시겠습니까?',
      deleteDatasetConfirmText: '데이터셋과 그 이미지가 삭제됩니다. 이미 모델로 전송된 이미지는 영향을 받지 않습니다.',
      datasetDeleted: '데이터셋을 삭제했습니다.',
      sourceVideo: '출처: {name}',
      download: '다운로드',
      downloadAll: '전체 다운로드',
      downloadTooltip: '선택한 이미지를 zip으로 다운로드',
      downloadAllTooltip: '데이터셋 전체를 zip으로 다운로드',
      downloading: '다운로드를 준비하는 중…',
      downloaded: '이미지 {count}개를 다운로드했습니다.',
      downloadFailed: '다운로드를 만들 수 없습니다',
    },

    build: {
      heading: '라벨링을 위해 이미지 준비',
      intro: '“{dataset}”의 이미지 {count}개입니다.',
      taskHeading: '1. 이 이미지를 무엇으로 만들까요?',
      taskClassification: '분류',
      taskClassificationHint: 'AI가 비슷한 프레임을 묶고, 각 그룹이 하나의 클래스가 됩니다.',
      taskDetection: '객체 검출',
      taskDetectionHint: '입력한 각 객체에 AI가 박스를 그립니다.',
      taskUnlabeled: '그냥 추가',
      taskUnlabeledHint: 'AI를 쓰지 않습니다. 라벨 없이 추가되며 직접 라벨링합니다.',
      classesHeading: '클래스를 몇 개로 나눌까요?',
      classesAuto: 'AI가 결정',
      classesFixed: '직접 지정',
      classCount: '클래스 수',
      classNames: '클래스 이름 (선택)',
      classNamesPlaceholder: '예: 비어있음, 적재중, 막힘',
      classNamesHint: '쉼표로 구분하세요. 비워두면 자동으로 이름이 붙습니다.',
      objectsHeading: '무엇을 찾을까요?',
      objectsPlaceholder: '예: 사람, 지게차, 헬멧',
      objectsHint: '쉼표로 구분해 일반적인 단어로 입력하세요. 각각이 하나의 클래스가 됩니다.',
      objectsRequired: '찾을 객체를 하나 이상 입력하세요.',
      confidence: '신뢰도',
      confidenceHint: '값이 높을수록 더 적지만 확실한 객체만 찾습니다.',
      destinationHeading: '2. 어디에 저장할까요?',
      appendNote: '이미지는 선택한 버전에 추가됩니다. 기존 데이터는 삭제되거나 대체되지 않으며, 이름이 겹치면 접미사가 붙습니다.',
      start: '시작',
      starting: '시작 중…',
      queued: '시작했습니다 — 이 페이지를 벗어나도 계속 실행됩니다.',
      failed: '시작할 수 없습니다',
      analysing: '이미지를 분석하는 중…',
      creating: '프로젝트와 모델을 생성하는 중…',
      writing: '이미지를 추가하는 중…',
      progressOf: '{total}개 중 {done}개',
      runningHeading: '이미지 준비 중',
      resultHeading: '라벨링 준비 완료',
      resultLine: '{model} 버전 {version}에 이미지 {imported}개 — 그중 {labeled}개에 라벨이 있습니다.',
      resultClasses: '클래스: {names}',
      openLabeling: '라벨링에서 열기',
      dismiss: '닫기',
      cancelBuild: '중지',
      cancelConfirmTitle: '준비를 중지할까요?',
      cancelConfirmText: '이미 생성된 항목은 삭제되므로 불완전한 결과가 남지 않습니다.',
      cancelled: '중지했습니다.',
      buildFailed: '준비 실패',
      versionHeading: '이 모델에 이미 있는 이미지에 라벨 지정',
      versionIntro: '{model} 버전 {version}에 라벨 없는 이미지가 {count}개 있습니다.',
      versionNothing: '이 버전의 모든 이미지에 이미 라벨이 있습니다.',
      versionNote: '이미지는 그대로 유지되며, 라벨이 없는 이미지에만 라벨이 지정됩니다. 직접 라벨링한 항목은 그대로 둡니다.',
      versionTarget: '대상',
    },
    transfer: {
      heading: '프로젝트 모델로 전송',
      intro: '“{dataset}”에서 이미지 {count}개를 추가합니다.',
      project: '프로젝트',
      model: '모델',
      version: '대상 버전',
      selectProject: '프로젝트를 선택하세요',
      selectModel: '모델을 선택하세요',
      noModels: '이 프로젝트에는 아직 모델이 없습니다',
      versionLatest: '버전 {version} — 현재 이미지 {count}개',
      versionNew: '새 버전 생성',
      appendNote: '이미지는 선택한 버전에 추가됩니다. 기존 데이터는 삭제되거나 대체되지 않으며, 이름이 겹치면 접미사가 붙습니다.',
      removeFromDataset: '이 데이터셋에서도 삭제',
      confirm: '이미지 {count}개 전송',
      transferring: '전송 중…',
      success: '{model} 버전 {version}에 이미지 {count}개를 추가했습니다 — 현재 총 {total}개입니다.',
      partial: '이미지 {count}개를 전송했으며, {failed}개는 복사할 수 없었습니다.',
      failed: '전송 실패',
      selectModelFirst: '먼저 프로젝트와 모델을 선택하세요.',
    },
  },
  aiLabel: {
    preLabel: {
      title: '학습된 모델 사용',
      hint: '이미 학습한 버전으로 이 버전의 라벨 초안을 만든 뒤 수정하세요.',
      version: '학습된 버전',
      confidence: '신뢰도',
      current: '현재 이미지',
      currentTip: '화면에 보이는 이미지를 사전 라벨링합니다',
      unlabeled: '미라벨 {count}장',
      unlabeledTip: '아직 라벨이 없는 모든 이미지를 사전 라벨링합니다',
      running: '실행 중…',
      progress: '{done} / {total} · {found}개 검출',
      stop: '중지',
      stopping: '중지하는 중…',
      stopTip: '사전 라벨링 중지',
      noDetections: '신뢰도 기준을 넘는 결과가 없습니다 — 기준값을 낮춰 보세요.',
      failed: '사전 라벨링 실패: {reason}',
    },
    panel: {
      title: 'AI 자동 라벨링',
      close: 'AI 패널 닫기',
    },
    mode: {
      label: '검출 모드',
      myclasses: {
        noClasses: '아직 클래스가 없어 스마트 모드로 대체됩니다 — 감지한 대상에 맞춰 클래스를 새로 만듭니다.',
        label: '내 클래스만 (권장)',
        hint: '직접 정의한 클래스만 검출하여 박스를 그립니다 — 새 클래스는 만들지 않습니다. 클래스의 “AI 검출 명칭”을 설정하면 AI가 찾을 대상을 지정할 수 있습니다.',
      },
      smart: {
        label: '스마트 (모두 검출)',
        hint: 'YOLO + SAM + CLIP — 내 클래스 외의 객체까지 찾아 새 클래스로 추가합니다',
      },
      coco: {
        label: 'COCO 표준 (80개 클래스)',
        hint: '빠르지만 일반적인 객체만 검출합니다',
      },
    },
    confidence: {
      label: '신뢰도',
      hint: '높이면 박스가 줄고 더 확실해지며, 낮추면 박스가 늘어납니다. 다음 실행에 적용되고, 현재 이미지의 기존 제안도 다시 필터링합니다.',
    },
    iou: {
      label: '겹침 허용 (IoU)',
      hint: '두 박스가 중복으로 처리되기 전까지 허용되는 겹침 정도입니다.',
    },
    nav: {
      autoLabel: '이미지를 열 때 자동으로 라벨링',
    },
    master: {
      use: '마스터 이미지 사용',
      hint: '기준 이미지 한 장에 박스를 직접 그리면, AI가 나머지 이미지에서 해당 객체 종류만 라벨링합니다.',
      set: '현재 이미지를 마스터로 지정',
      current: '마스터: {name}',
      boxes: '박스 {boxes}개 · 클래스 {classes}개',
      noBoxes: '마스터 이미지에 박스를 그리고 각 박스에 클래스를 지정한 뒤 아래에서 자동 라벨링을 실행하세요.',
      clear: '마스터 해제',
      goto: '마스터 이미지 열기',
      run: '마스터 기준 자동 라벨링 ({count})',
      runTip: '마스터의 클래스만 사용해 남은 이미지를 라벨링합니다',
      similarity: '외형 유사도',
      similarityHint: '검출된 객체가 직접 그린 박스와 얼마나 닮아야 하는지 설정합니다. 0 = 사용 안 함 (클래스만 제한).',
      missingTitle: '마스터 이미지가 없습니다',
      missingText: '먼저 마스터 이미지를 지정하고 클래스가 있는 박스를 최소 1개 그려주세요.',
      emptyTitle: '마스터에 박스가 없습니다',
      emptyText: '마스터 이미지에 박스를 최소 1개 그리고 클래스를 지정해주세요.',
      aloneTitle: '라벨링할 다른 이미지가 없습니다',
      aloneText: '라벨이 없는 이미지는 마스터 이미지뿐입니다.',
      unclassedTitle: '클래스가 없는 마스터 박스가 있습니다',
      unclassedText: '마스터 이미지의 박스 {count}개에 클래스가 없어 무시됩니다.',
      marker: 'AI 자동 라벨링 기준 마스터 이미지',
      badge: '마스터',
    },
    action: {
      detectThis: '이 이미지 검출',
      detectThisTip: '현재 이미지에서 객체를 검출합니다',
      detecting: '검출 중…',
      detectAll: '라벨 없는 이미지 전체 자동 라벨링 ({count})',
      detectAllTip: '라벨이 없는 모든 이미지를 자동 라벨링합니다',
      stop: '중지',
      stopTip: '자동 라벨링을 중지합니다 — 이미 생성된 박스는 유지됩니다',
      stopping: '중지 중…',
    },
    progress: {
      counts: '{done}/{total} 이미지 · 박스 {found}개',
    },
    review: {
      suggestions: 'AI 제안 {count}개',
      accept: '전체 적용',
      acceptTip: '이 이미지의 AI 박스를 모두 유지합니다',
      discard: '삭제',
      discardTip: '이 이미지의 AI 박스를 모두 제거합니다',
      hint: '점선 박스는 제안입니다 — 일반 박스처럼 이동/크기 조절/삭제할 수 있고, 오른쪽 패널에서 클래스를 변경할 수 있습니다.',
    },
    result: {
      stopped: '자동 라벨링 중지됨',
      complete: '자동 라벨링 완료',
      summary: '이미지 <b>{done}</b>개에 AI 박스 <b>{found}</b>개를 라벨링했습니다.',
      newClasses: '새 클래스 <b>{count}</b>개가 생성되었습니다.',
      failed: '이미지 {count}개 실패.',
      reviewNote: '제안은 점선으로 표시됩니다 — 확인하고 수정한 뒤 적용하세요.',
      navOff: '다시 시작되지 않도록 “열 때 자동 라벨링”을 해제했습니다.',
      noObjects: '새로 검출된 객체가 없습니다',
      allLabeled: '모든 이미지에 이미 라벨이 있습니다',
      detectFailed: '자동 검출 실패',
      unknownError: '알 수 없는 오류',
      gateOffTitle: '외형 유사도 검사를 사용할 수 없습니다',
      gateOff: '이번 실행에서는 외형 유사도 검사가 꺼져 있었습니다 — 마스터 클래스 이름으로만 제한되었고, 외형은 비교하지 않았습니다. 원인: {reason}',
      notFoundClasses: '어떤 이미지에서도 찾지 못한 클래스: <b>{list}</b>. 신뢰도나 외형 유사도를 낮추거나, 해당 클래스에 “AI 검출 명칭” 별칭을 추가해 보세요.',
    },
    upload: {
      title: 'AI 자동 라벨링을 실행할까요?',
      body: '새 이미지 <b>{count}</b>개가 업로드되었습니다.<br/>모든 객체를 자동으로 검출할까요?',
      confirm: '지금 자동 라벨링',
      cancel: '나중에',
    },
  },

  autoGroup: {
    emptyTitle: '아직 클래스가 없습니다',
    emptyWithAi: 'AI가 그룹을 찾게 하거나, 오른쪽에서 개수를 정하고 클래스 만들기를 누르세요.',
    emptyManual: '오른쪽에서 개수를 정하고 클래스 만들기를 눌러 시작하세요.',
    title: '자동으로 묶어 주세요',
    open: 'AI 그룹화',
    lead: '미라벨 이미지 {count}장을 외형에 따라 그룹으로 나눕니다.',
    capped: '총 {total}장 중 {count}장을 묶습니다. 나머지 {rest}장은 미라벨로 남습니다.',
    notEnough: '미라벨 이미지를 최소 {min}장 추가해 주세요. 비교할 대상이 필요합니다.',
    howMany: '그룹을 몇 개로 나눌까요?',
    auto: '알아서 찾기',
    run: '그룹으로 나누기',
    stop: '중지',
    reading: '이미지 읽는 중… {total}장 중 {done}장',
    grouping: '그룹을 찾는 중…',
    result: '이미지 {grouped}장을 {groups}개 그룹으로 나눴습니다. 오른쪽에서 이름을 지정하세요.',
    resultRest: '{count}장은 미라벨로 남았습니다.',
    footnote: '저장을 누르기 전에는 반영되지 않습니다. 잘못된 이미지는 다른 클래스로 끌어다 놓으면 됩니다.',
  },
  assistant: {
    title: 'AI 어시스턴트',
    welcome: {
      title: '무엇을 만들고 계신가요?',
      titleNamed: '{name}님, 무엇을 만들고 계신가요?',
      subtitle:
        '모델 선택, 데이터셋 규모, 라벨링 전략, 학습 결과에 대해 물어보세요. 프로젝트와 모델을 직접 읽을 수 있어 실제 데이터를 근거로 답변합니다.',
      contextLine: '프로젝트 {projects}개, 모델 {models}개, 이미지 {images}장을 참조 중',
    },
    badge: {
      ready: '준비됨',
      limited: '제한 모드',
      grounded: '내 데이터',
      stopped: '중지됨',
      yourData: '내 데이터',
    },
    modelType: {
      classification: '분류',
      detection: '객체 검출',
      segmentation: '세그멘테이션',
      unknown: '알 수 없는 유형',
    },
    trainingStatus: {
      pending: '미학습',
      queued: '대기 중',
      inprogress: '학습 중',
      completed: '학습 완료',
      failed: '실패',
    },
    quick: {
      heading: '이동',
      projects: '프로젝트',
      models: '모델',
      video: '동영상 → 이미지',
      hub: '모델 허브',
      predict: '예측',
    },
    suggest: {
      compare: {
        label: '분류일까요, 검출일까요?',
        prompt:
          '이미지 분류와 객체 검출 중에서 선택해야 합니다. 실무 관점에서 차이를 설명하고, 실제 검사 사례에는 어느 쪽이 맞는지 골라 주세요.',
      },
      datasetSize: {
        label: '데이터가 얼마나 필요한가요?',
        prompt:
          '학습을 돌릴 만한 수준이 되려면 클래스당 라벨링된 이미지가 몇 장 필요한가요? 그보다 적으면 어떤 문제가 생기나요?',
      },
      split: {
        label: '학습 / 검증 / 테스트 분할',
        prompt:
          '데이터셋을 학습, 검증, 테스트로 어떻게 나눠야 하나요? 그리고 이 분할이 왜 중요한가요?',
      },
      classes: {
        label: '클래스 설계하기',
        prompt:
          '데이터셋의 클래스를 어떻게 정하고 이름 붙여야 하나요? 넓은 클래스 몇 개가 좋을까요, 세분화된 클래스 여러 개가 좋을까요?',
      },
      video: {
        label: '동영상에서 데이터셋으로',
        prompt:
          '정지 이미지가 아니라 동영상 자료를 가지고 있습니다. 이것을 라벨링된 학습 데이터셋으로 만드는 가장 좋은 방법은 무엇인가요?',
      },
      metrics: {
        label: '지표 읽는 법',
        prompt:
          'mAP50, mAP50-95, precision, recall을 설명해 주세요. 모델 성능이 낮을 때 가장 먼저 확인해야 할 지표는 무엇인가요?',
      },
      firstProject: {
        label: '첫 프로젝트 시작하기',
        prompt:
          'LabelFlow를 처음 씁니다. 빈 계정에서 학습된 모델까지 가는 과정을 단계별로 안내해 주세요.',
      },
      pickType: {
        label: '어떤 모델 유형이 맞나요?',
        prompt:
          '제 사용 사례에 맞는 모델 유형을 골라 주세요. 필요한 내용이 있으면 먼저 저에게 물어봐 주세요.',
      },
      ctxReview: {
        label: '학습 결과 검토',
        prompt:
          '제 모델 "{model}" 버전 {version}의 학습 결과를 검토해 주세요. 지표가 무엇을 말하고 있고, 개선하려면 무엇을 바꿔야 하나요?',
      },
      ctxUnlabeled: {
        label: '{count}장이 아직 미라벨 상태',
        prompt:
          '제 모델 "{model}"에는 전체 {total}장 중 {count}장이 라벨링되지 않았습니다. 이것들을 라벨링하고 모델을 학습시키는 가장 효율적인 방법은 무엇인가요?',
      },
      ctxThin: {
        label: '데이터셋이 충분한가요?',
        prompt:
          '제 모델 "{model}"에는 {classes}개 클래스에 걸쳐 라벨링된 이미지가 {labeled}장 있습니다. 학습에 충분한가요? 부족하다면 어떻게 해야 하나요?',
      },
      ctxReady: {
        label: '학습 준비 완료 — 다음은?',
        prompt:
          '제 모델 "{model}"은 {count}장 모두 라벨링이 끝났습니다 ({type}). 지금 학습해야 할까요? 어떤 설정을 쓰면 좋을까요?',
      },
    },
    sidebar: {
      heading: '대화 목록',
      newChat: '새 대화',
      searchPlaceholder: '대화 검색',
      today: '오늘',
      yesterday: '어제',
      week: '지난 7일',
      older: '이전',
      untitled: '제목 없는 대화',
      empty: '메시지가 없습니다',
      count: '메시지 {count}개',
      noThreads: '아직 대화가 없습니다. 질문을 입력해 시작하세요.',
      noMatches: '검색과 일치하는 대화가 없습니다.',
      rename: '이름 변경',
      delete: '삭제',
      deleteTitle: '대화 삭제',
      deleteBody: '"{title}" 대화를 삭제할까요? 되돌릴 수 없습니다.',
      clearAll: '모든 대화 삭제',
      clearTitle: '모든 대화 삭제',
      clearBody: '저장된 모든 대화가 삭제됩니다. 되돌릴 수 없습니다.',
    },
    topbar: {
      collapseSidebar: '대화 목록 숨기기',
      expandSidebar: '대화 목록 보기',
      workspace: '어시스턴트가 볼 수 있는 워크스페이스',
      more: '추가 작업',
      export: 'Markdown으로 내보내기',
      copyAll: '전체 대화 복사',
    },
    thread: {
      jump: '최신 메시지로 이동',
    },
    message: {
      yours: '내 메시지',
      reply: '어시스턴트 답변',
      thinking: '생각 중…',
      empty: '답변이 오지 않았습니다. 다시 질문해 보세요.',
      stopped: '텍스트가 도착하기 전에 중지되었습니다.',
      copy: '복사',
      copied: '복사됨',
      edit: '수정',
      editLabel: '메시지 수정',
      saveAndResend: '저장 후 다시 보내기',
      regenerate: '다시 생성',
      retry: '다시 시도',
    },
    composer: {
      placeholder: '모델 선택, 데이터셋 규모, 학습 결과에 대해 물어보세요…',
      label: 'AI 어시스턴트에게 질문하기',
      send: '보내기',
      stop: '생성 중지',
      hint: 'Enter 전송 · Shift+Enter 줄바꿈',
      contextOn: '워크스페이스 사용 중',
      contextOff: '워크스페이스 사용 안 함',
      contextHint:
        '켜면 프로젝트, 모델, 라벨링 수량이 질문과 함께 전송되어 답변에서 실제 데이터를 참조할 수 있습니다.',
      contextUnavailable: '전송할 워크스페이스 데이터가 없습니다.',
    },
    context: {
      heading: '내 워크스페이스',
      useLabel: '내 워크스페이스를 근거로 답변',
      useHint: '질문할 때마다 프로젝트, 모델, 이미지 수량 요약을 함께 보냅니다.',
      projects: '프로젝트',
      models: '모델',
      images: '이미지',
      unlabeled: '미라벨',
      none: '아직 아무것도 없습니다. 프로젝트와 모델을 만들면 어시스턴트가 여기서 읽어옵니다.',
      rowMeta: '이미지 {total}장 · 라벨링 {labeled}장 · 클래스 {classes}개',
      rowUnlabeled: '{count}장이 아직 미라벨',
      ask: '이것에 대해 질문',
      askPrompt:
        '제 모델 "{model}" 버전 {version}에 대해 알려주세요. 현재 어떤 상태이고, 다음에 무엇을 해야 하나요?',
    },
    shortcuts: {
      title: '키보드 단축키',
      send: '메시지 전송',
      newline: '줄바꿈',
      newChat: '새 대화 시작',
      editLast: '마지막 메시지 수정 (입력창이 빈 경우)',
      stop: '생성 중지',
      focus: '입력창으로 이동',
      help: '이 목록 보기',
    },
    export: {
      copiedTitle: '복사됨',
      copiedBody: '대화가 Markdown 형식으로 클립보드에 복사되었습니다.',
      failTitle: '완료할 수 없습니다',
      failBody: '브라우저가 다운로드 또는 클립보드 접근을 차단했습니다.',
    },
    interview: {
      title: '제가 설정해 드릴게요',
      reading: '압축 파일을 읽는 중…',
      facts: '사용 가능한 이미지 {images}장 · {size}',
      willImport: '한 번에 {count}장을 가져올 수 있습니다.',
      droppedCount: '{count}장은 한 번의 가져오기에 담기지 않습니다.',
      droppedBytes: '{count}장은 업로드 용량 제한을 넘습니다.',
      ask: {
        task: '이 이미지로 무엇을 하고 싶으세요?',
        grouping: '어떻게 묶을까요?',
        objects: '어떤 객체를 찾을까요?',
        objectsHint: '말하듯이 적어 주세요 — "헬멧, 안전조끼, 사람".',
        objectsCost: '이미지 {images}장을 살펴봅니다 — GPU 환경에서 약 {seconds}초, 없으면 더 걸립니다.',
      },
      task: {
        classification: '그룹으로 분류하기',
        detection: '객체 찾기',
        manual: '가져오기만 하고 직접 라벨링',
      },
      grouping: {
        auto: '알아서 묶어 주세요',
        few: '적게 (최대 4개)',
        many: '많게 (최대 8개)',
        named: '제가 이름을 정할게요',
        folders: '폴더가 곧 클래스',
        explicit: '{count}개 그룹',
        unlabeled: '미라벨로 가져오기',
      },
      summary: {
        task: '목표',
        grouping: '분류 방식',
        objects: '찾을 대상',
        fromArchive: '파일에서',
        fromYou: '입력한 내용',
      },
      change: '변경',
      back: '뒤로',
      notUnderstood: '"{text}"로 읽었는데 이 질문의 답으로는 맞지 않습니다. 아래에서 고르거나 다르게 말해 주세요.',
      segmentUnsupported:
        '아직 마스크를 자동으로 만들 수는 없습니다. 이미지를 세그멘테이션 모델로 가져와 직접 그리시거나, 대신 박스로 객체를 찾을 수 있습니다.',
      status: {
        starting: '시작하는 중…',
        step: '{step}…',
        grouping: '이미지 {count}장을 비슷한 것끼리 묶는 중…',
        boxing: '{names} 찾는 중…',
        verifying: '이미지 {total}장 중 {done}장 도착',
        elapsed: '{seconds}초',
        busyHint: '현재 단계가 끝난 뒤에 변경하거나, 지금 중지할 수 있습니다.',
      },
      working: {
        cluster: '이미지 {count}장을 외형에 따라 묶는 중…',
        autobox: '{names} 찾는 중 — {total}장 중 {done}장',
        stop: '중지',
        stopRun: '가져오기 중지',
        stopKeep: '중지하고 지금까지 결과 사용',
      },
      review: {
        failedImages: '이미지 {count}장에서 감지기에 연결하지 못했습니다 — 입력한 단어가 아니라 서버 문제입니다.',
        title: '찾은 결과입니다',
        coverage: '이미지 {total}장 중 {found}장에서 박스를 찾았습니다',
        lowCoverage: '찾은 것이 거의 없습니다. 입력한 단어가 이미지와 맞지 않을 수 있으니 다른 표현을 시도해 보세요.',
        threshold: '신뢰도',
        retry: '다른 단어로 다시',
        groupCount: '이미지 {count}장',
        rename: '이름 변경',
        grouped: '이미지 {count}장을 {groups}개 그룹으로 묶었습니다',
        stopped: '중간에 중지하여 일부만 처리되었습니다.',
      },
      confirm: {
        title: '준비되었습니다',
        newProject: '새 프로젝트 "{project}"',
        existingProject: '기존 프로젝트 "{project}"에 추가',
        modelLine: '새 {type} 모델 "{model}"',
        imagesLine: '이미지 {count}장 가져오기',
        droppedLine: '{count}장 제외',
        classesLine: '클래스 {count}개: {names}',
        warnRepeat: '다시 실행하면 프로젝트가 하나 더 생성됩니다.',
        projectsUnreadable: '프로젝트 목록을 읽지 못해 새로 만듭니다.',
        go: '생성하고 이미지 {count}장 가져오기',
        cancel: '아직 아니요',
        editProject: '프로젝트 이름',
        editModel: '모델 이름',
        pickProject: '다른 곳에 넣기',
      },
      finish: {
        openStudio: '라벨링 화면 열기',
        queueTraining: '학습 대기열에 추가',
        queued: '학습이 대기열에 추가되었습니다. GPU가 비면 시작됩니다.',
        failed: '가져오기가 완료되지 않아 아무것도 저장되지 않았습니다.',
        blockedNoLabels: '아직 라벨이 없어 학습할 데이터가 없습니다.',
        blockedOneClass: '학습하려면 클래스가 최소 2개 필요합니다.',
        blockedTooFew: '클래스당 라벨 이미지가 {count}장뿐입니다. 최소 10장을 권장합니다.',
        blockedPartial: '일부 이미지가 도착하지 않아 불완전한 데이터로 학습하게 됩니다.',
      },
    },
    attach: {
      button: '데이터셋 첨부',
      hint: '이미지 .zip 파일 첨부',
      replace: '교체',
      remove: '첨부 제거',
      dropTitle: '여기에 데이터셋을 놓으세요',
      dropBody: '이미지가 담긴 .zip 파일입니다. 내부 폴더가 클래스가 됩니다.',
      reading: '{name} 읽는 중…',
      phaseUnpacking: '압축 푸는 중…',
      phaseScanning: '파일 {count}개 확인 중…',
      phaseLabels: '이미지 {count}개 발견 — 라벨 읽는 중…',
      folderButton: '폴더 첨부',
      failed: '해당 압축 파일을 읽을 수 없습니다.',
      notZip: '.zip 파일을 첨부해 주세요.',
      tooLarge: '파일 크기가 {size}로 제한({limit})을 초과합니다.',
      empty: '압축 파일에서 사용할 수 있는 이미지를 찾지 못했습니다.',
      summary: '이미지 {images}장 · {size}',
      folders: '폴더 {count}개',
      skipped: '파일 {count}개 제외됨',
      layoutFolders: '폴더별 클래스',
      layoutFlat: '분류 없음',
      layoutYolo: 'YOLO 박스',
      layoutCoco: 'COCO 박스',
      unsupportedVoc: 'Pascal VOC 박스는 아직 가져오지 않습니다. 이미지는 미라벨로 들어갑니다.',
      classPreview: '클래스: {names}',
      expired: '이 탭에 파일이 더 이상 남아 있지 않습니다. 다시 첨부해 주세요.',
      context: '[첨부 {name}: 이미지 {images}장, 폴더 {folders}개, 구조: {layout}]',
      seed: {
        foldersLabel: '폴더를 클래스로 사용',
        foldersPrompt: '이 데이터셋의 폴더를 클래스로 사용해서 모델을 만들어줘.',
        splitLabel: '3개 클래스로 나누기',
        splitPrompt: '이 이미지들을 3개 클래스로 나눠서 모델을 만들어줘.',
        unlabeledLabel: '미라벨로 가져오기',
        unlabeledPrompt: '이 이미지들을 미라벨 상태로 가져와줘. 직접 라벨링할게.',
        askLabel: '여기에 뭐가 들어있나요?',
        askPrompt: '이 압축 파일 안에 무엇이 있고, 어떻게 활용하면 좋을까요?',
      },
    },
    build: {
      title: '데이터셋으로 만들기',
      subtitle: '만들기를 누르기 전에는 아무것도 생성되지 않습니다.',
      project: '프로젝트',
      model: '모델',
      classesLabel: '클래스',
      imagesLabel: '이미지',
      groupingLabel: '분류 방식',
      run: '만들기',
      running: '진행 중…',
      cancel: '취소',
      retry: '다시 시도',
      dismiss: '닫기',
      editNames: '이름 편집',
      namePlaceholder: '클래스 이름',
      mode: {
        folders: '폴더를 클래스로',
        cluster: '유사도로 그룹화',
        unlabeled: '미라벨로 가져오기',
        annotations: '파일에 포함된 박스',
      },
      modeHint: {
        folders: '압축 파일의 각 폴더가 하나의 클래스가 됩니다.',
        cluster: '이미지를 외형에 따라 묶은 뒤 각 그룹의 이름을 지정합니다.',
        unlabeled: '전부 미라벨 상태로 가져와 라벨링 화면에서 바로 작업합니다.',
        annotations: '압축 파일에 이미 박스가 들어 있어 그대로 가져옵니다.',
      },
      step: {
        cluster: '이미지 그룹화',
        project: '프로젝트 생성',
        model: '모델 생성',
        upload: '이미지 업로드',
        verify: '도착 확인',
      },
      state: {
        pending: '대기 중',
        running: '진행 중',
        done: '완료',
        skipped: '해당 없음',
        failed: '실패',
      },
      note: {
        projectReused: '기존 프로젝트 "{name}"을(를) 사용합니다.',
        projectRenamed: '같은 이름의 프로젝트가 있어 "{name}"으로 만들었습니다.',
        modelRenamed: '같은 이름의 모델이 있어 "{name}"으로 만들었습니다.',
        clusterSampled: '이미지 {total}장 중 {sampled}장으로 그룹을 계산했고, 나머지는 미라벨로 들어갑니다.',
        capped: '이미지 {dropped}장은 가져오지 않습니다. 한 번에 {limit}까지만 가능합니다.',
        duplicates: '클래스 안에서 파일명 {count}개가 중복되어 번호를 붙여 구분합니다.',
        splitFolders: 'train/ 과 val/ 폴더를 하나의 클래스 묶음으로 읽었습니다.',
        boxesFound: '이미지 {images}장에서 박스 {boxes}개를 찾았습니다.',
        inventedClasses: '압축 파일에 없는 클래스 이름 {count}개를 번호로 채웠습니다.',
        segmentFiles: '라벨 파일 {count}개는 박스가 아닌 폴리곤이라 건너뛰었습니다.',
        missingSize: '이미지 {count}장의 픽셀 크기를 읽지 못했습니다. 박스 위치가 어긋날 수 있습니다.',
      },
      result: {
        done: '{model}에 이미지 {imported}장을 가져왔습니다.',
        partial: '이미지 {expected}장 중 {imported}장만 도착했습니다. 나머지는 아직 업로드 중일 수 있습니다.',
        failed: '아무것도 가져오지 못했습니다: {reason}',
        cancelled: '중지했습니다. 이미 생성된 항목은 위에 표시됩니다.',
        openProject: '프로젝트 열기',
        openModel: '모델 열기',
        openLabeling: '라벨링 시작',
      },
      mirror: {
        folders: '폴더 {classes}개에 담긴 이미지 {images}장으로 프로젝트 **{project}** 안에 **{model}**을(를) 만듭니다.',
        cluster: '이미지 {images}장을 {classes}개 클래스로 묶어 프로젝트 **{project}** 안에 **{model}**을(를) 만듭니다.',
        unlabeled: '이미지 {images}장을 미라벨로 가져와 프로젝트 **{project}** 안에 **{model}**을(를) 만듭니다.',
        annotations: '이미 {classes}개 클래스로 라벨링된 이미지 {images}장으로 프로젝트 **{project}** 안에 **{model}**을(를) 만듭니다.',
        classes: '클래스: {names}',
        capped: '제한: 이미지 {total}장 중 {dropped}장은 가져오지 않습니다.',
        done: '프로젝트 **{project}**와 모델 **{model}**을(를) 만들고 이미지 {imported}장을 넣었습니다.',
        partial: '**{model}**을(를) 만들었지만 이미지 {expected}장 중 {imported}장만 도착했습니다.',
        failed: '가져오기를 완료하지 못했습니다: {reason}',
        cancelled: '가져오기를 중지했습니다.',
      },
      guard: {
        title: '이 대화에서 생성된 항목이 있습니다',
        body: '위의 데이터셋 가져오기에서 프로젝트와 모델이 이미 생성되었습니다. 대화를 다시 쓰더라도 취소되지 않습니다. 계속할까요?',
        confirm: '계속',
      },
      error: {
        signedOut: '데이터셋을 가져오려면 다시 로그인해 주세요.',
        noPlan: '이 압축 파일로 만들 수 있는 것이 없습니다.',
      },
    },
    error: {
      generic: '어시스턴트에 연결하는 중 문제가 발생했습니다. 다시 시도해 주세요.',
    },
  },
  prediction: {
    title: '예측',
    subtitle: '학습시킨 모델을 처음 보는 이미지로 시험해 보세요.',
    type: {
      classification: '분류',
      detection: '객체 검출',
      segmentation: '세그멘테이션',
      unknown: '모델',
    },
    models: {
      title: '학습된 모델',
      loading: '모델을 불러오는 중…',
      searchPlaceholder: '모델 또는 클래스 검색',
      classCount: '클래스 {count}개',
      unavailable: '사용 불가',
      noOwner: '로그아웃되었습니다',
      noOwnerHint: '학습한 모델을 보려면 다시 로그인해 주세요.',
      error: '모델을 불러오지 못했습니다',
      noModels: '아직 모델이 없습니다',
      noModelsHint: '프로젝트와 모델을 만들고 이미지를 라벨링한 뒤 학습을 실행하세요.',
      noneTrained: '학습이 완료된 버전이 없습니다',
      noneTrainedHint: '학습이 끝난 버전만 예측에 사용할 수 있습니다.',
      noMatch: '일치하는 모델이 없습니다',
      noMatchHint: '클래스 이름으로 검색하거나 검색어를 지워 보세요.',
    },
    panel: {
      pickModel: '모델을 선택하세요',
      pickModelHint: '왼쪽에서 학습된 버전을 고른 다음, 확인할 이미지를 추가하세요.',
      dropTitle: '이미지를 여기에 놓으세요',
      dropHint: '클릭해서 선택할 수도 있습니다. JPG, PNG, WEBP, BMP, TIFF.',
      addMore: '이미지 더 추가',
      confidence: '신뢰도',
      run: '실행',
      runAgain: '다시 실행',
      stop: '중지',
      clear: '비우기',
      progressRunning: '{total}개 중 {done}개 진행 중',
      progressIdle: '{total}개 중 {done}개 완료',
    },
    rejected: {
      unsupported: '{name}은(는) 이 모델이 읽을 수 없는 형식입니다.',
      tooLarge: '{name}의 크기가 40MB를 넘습니다.',
    },
    result: {
      title: '결과',
      idle: '결과가 여기에 표시됩니다',
      pending: '아직 실행하지 않았습니다',
      running: '모델을 실행하는 중…',
      failedTitle: '예측에 실패했습니다',
      nothing: '찾은 것이 없습니다',
      nothingHint: '신뢰도 {conf}% 이상으로 확신하는 대상을 찾지 못했습니다. 값을 낮추면 더 보입니다.',
      predictedClass: '예측 클래스',
      confident: '신뢰도 {value}',
      allClasses: '전체 클래스',
      found: '{count}개 발견',
      image: '이미지',
      model: '모델',
      took: '소요 시간',
      size: '크기',
    },
  },
};

export default ko;
